import { Component, Input } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-switch',
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.scss'],
})
export class SwitchComponent {
  @Input() on: string = '';
  @Input() off: string = '';
  @Input() id = 'check';
  @Input() control: FormControl = new FormControl(true, [Validators.required]);
  @Input() checked: boolean = true;
}
